import DeleteIcon from '@mui/icons-material/Delete';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
// import { alpha } from "@mui/material/styles";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { deleteFile } from '../../Api/suiviMission/files';
import { API_SERVER_FILES } from '../../config';
import formatDate from '../../Utils/dateFormatter';

// function descendingComparator(a, b, orderBy) {
//   if (b[orderBy] < a[orderBy]) {
//     return -1;
//   }
//   if (b[orderBy] > a[orderBy]) {
//     return 1;
//   }
//   return 0;
// }

// function getComparator(order, orderBy) {
//   return order === "desc"
//     ? (a, b) => descendingComparator(a, b, orderBy)
//     : (a, b) => -descendingComparator(a, b, orderBy);
// }

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) {
//       return order;
//     }
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }

// const headCells = [
//   {
//     id: "file",
//     numeric: false,
//     disablePadding: false,
//     label: "Fichier",
//   },
//   {
//     id: "info",
//     numeric: false,
//     disablePadding: false,
//     label: "",
//   },
//   //   {
//   //     id: "comment",
//   //     numeric: false,
//   //     disablePadding: false,
//   //     label: "Commentaire",
//   //   },
// ];

// function EnhancedTableHead(props) {
//   const {
//     onSelectAllClick,
//     // order,
//     // orderBy,
//     numSelected,
//     rowCount,
//     // onRequestSort,
//   } = props;

//   // const createSortHandler = (property) => (event) => {
//   //   onRequestSort(event, property);
//   // };

//   return (
//     <TableHead>
//       <TableRow>
//         <TableCell
//           style={{
//             backgroundColor: "#E3E6EA",
//             borderRadius: "10px 0px 0px 0px",
//           }}
//         ></TableCell>
//         {headCells.map((headCell) => (
//           <TableCell
//             style={{ backgroundColor: "#E3E6EA", borderRadius: "0px  0px" }}
//             key={headCell.id}
//             align={headCell.numeric ? "left" : "left"}
//             padding={headCell.disablePadding ? "none" : "normal"}
//           // sortDirection={orderBy === headCell.id ? order : false}
//           >
//             {/* <TableSortLabel
//               active={orderBy === headCell.id}
//               direction={orderBy === headCell.id ? order : "asc"}
//               onClick={createSortHandler(headCell.id)}
//             >
//               {headCell.label}
//               {orderBy === headCell.id ? (
//                 <Box component="span" sx={visuallyHidden}>
//                   {order === "desc" ? "sorted descending" : "sorted ascending"}
//                 </Box>
//               ) : null}
//             </TableSortLabel> */}
//           </TableCell>
//         ))}
//       </TableRow>
//     </TableHead>
//   );
// }

// EnhancedTableHead.propTypes = {
//   numSelected: PropTypes.number.isRequired,
//   onRequestSort: PropTypes.func.isRequired,
//   onSelectAllClick: PropTypes.func.isRequired,
//   order: PropTypes.oneOf(["asc", "desc"]).isRequired,
//   orderBy: PropTypes.string.isRequired,
//   rowCount: PropTypes.number.isRequired,
// };

// const EnhancedTableToolbar = (props) => {
//   const { numSelected } = props;

//   return (
//     <Toolbar
//       sx={{
//         pl: { sm: 2 },
//         pr: { xs: 1, sm: 1 },
//       }}
//     >
//       <Typography
//         sx={{ flex: "1 1 100%" }}
//         variant="h6"
//         id="tableTitle"
//         component="div"
//       >
//         Fichiers partagés :
//       </Typography>

//       <Tooltip title="Filter list">
//         <IconButton>
//           <FilterListIcon />
//         </IconButton>
//       </Tooltip>
//     </Toolbar>
//   );
// };

// EnhancedTableToolbar.propTypes = {
//   numSelected: PropTypes.number.isRequired,
// };

export default function FileList({ list, setlist }) {
    FileList.propTypes = {
        list: PropTypes.any,
        setlist: PropTypes.func,
    };
    // const [order, setOrder] = React.useState("asc");
    // const [orderBy, setOrderBy] = React.useState("calories");
    const [selected, setSelected] = React.useState([]);
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(7);
    const { i18n } = useTranslation();
    // const handleRequestSort = (event, property) => {
    //   const isAsc = orderBy === property && order === "asc";
    //   setOrder(isAsc ? "desc" : "asc");
    //   setOrderBy(property);
    // };
    // React.useEffect(() => {
    //   console.log("fileList UseEffect order, orderBy, list", order, orderBy, list)
    // }, [order, orderBy, list])

    // const handleSelectAllClick = (event) => {
    //   if (event.target.checked) {
    //     const newSelecteds = list.map((n) => n.id);
    //     setSelected(newSelecteds);
    //     return;
    //   }
    //   setSelected([]);
    // };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }

        setSelected(newSelected);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const isSelected = (id) => selected.indexOf(id) !== -1;

    // Avoid a layout jump when reaching the last page with empty list.
    const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - list?.length) : 0;

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
                <TableContainer>
                    <Table
                        sx={{ width: '100%', height: '100%' }}
                        aria-labelledby="tableTitle"
                        size={'small'}
                    >
                        {/* <EnhancedTableHead
              numSelected={selected.length}
              // order={order}
              // orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              // onRequestSort={handleRequestSort}
              rowCount={list.length}
            /> */}
                        <TableBody>
                            {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                 list.slice().sort(getComparator(order, orderBy)) */}
                            {/* stableSort(list,
                 getComparator(order, orderBy)
              ) */}
                            {
                                list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((row, index) => {

                                        console.warn(row, index);
                                        const isItemSelected = isSelected(row?._id);
                                        {/* const labelId = `enhanced-table-checkbox-${index}`; */ }

                                        return (
                                            <TableRow
                                                // key={index}
                                                key={row?._id}
                                                hover
                                                onClick={(event) => handleClick(event, row?._id)}
                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                selected={isItemSelected}
                                            >
                                                {/* <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={isItemSelected}
                          inputProps={{
                            "aria-labelledby": labelId,
                          }}
                        />
                      </TableCell> */}

                                                <TableCell
                                                    style={{ width: 10 }}
                                                    align="center"
                                                >
                                                    <IconButton
                                                        onClick={() => {
                                                            console.log(row);
                                                            deleteFile(setlist, row?._id);
                                                        }}
                                                    >
                                                        <DeleteIcon />
                                                    </IconButton>
                                                </TableCell>

                                                <TableCell
                                                    style={{ width: 130 }}
                                                    align="left"
                                                >
                                                    {/* put file name as link to view file here */}
                                                    <a
                                                        href={API_SERVER_FILES + encodeURIComponent(row?.path)}
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        {row?.name}
                                                    </a>
                                                </TableCell>
                                                <TableCell
                                                    align="left"
                                                    style={{ width: 180 }}
                                                >
                                                    <span style={{ color: '#1976D2' }}> {i18n.t('uploader')}</span>
                                                    <span style={{ color: '#4D5864' }}>
                                                        {' '}
                                                        {formatDate(row?.createdAt)}
                                                    </span>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            {emptyRows > 0 && (
                                <TableRow
                                    style={{
                                        height: 52 * emptyRows,
                                    }}
                                >
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={list?.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
        </Box >
    );
}